import script from "./RicetteTable4.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable4.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable4.vue?vue&type=style&index=0&id=22942a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22942a96"]])

export default __exports__